import { TestStep } from '../../../models/test-case.model';

export const DRAFT_ID = '__draft__';
export const LOCAL_ID_PREFIX = 'local-';

export function isLocalId(id: string): boolean {
  return id.startsWith(LOCAL_ID_PREFIX);
}

export function isDraftId(id: string): boolean {
  return id === DRAFT_ID;
}

export function nextLocalId(seed: number): string {
  return `${LOCAL_ID_PREFIX}${seed}`;
}

export function createLocalStep(
  id: string,
  orderIndex: number,
  action: string,
  expectedResult: string | null,
  notes: string | null,
  // NEX-546: Referenz-Zeilen muessen ALLE vom Mapper geschickten Inhaltsfelder tragen, sonst nullt
  // der Link-Save (testStepId-Zweig) sie auf der GETEILTEN Definition (Datenverlust ueber Kontexte).
  overrides: Partial<
    Pick<
      TestStep,
      | 'title'
      | 'libraryStepId'
      | 'kind'
      | 'status'
      | 'calledModuleId'
      | 'stepRole'
      | 'category'
      | 'assigneeUserId'
      | 'assigneeName'
      | 'tags'
      | 'tcdl'
    >
  > = {},
): TestStep {
  const now = new Date().toISOString();
  return {
    id,
    kind: 'ACTION',
    orderIndex,
    action,
    expectedResult,
    notes,
    status: 'DRAFT',
    libraryStepId: null,
    createdAt: now,
    updatedAt: now,
    ...overrides,
  };
}

export function createDraftStep(orderIndex: number): TestStep {
  return createLocalStep(DRAFT_ID, orderIndex, '', '', '');
}

/**
 * NEX-538: Lokale MODULE_REF-Zeile — bindet ein ganzes Modul als aufklappbaren
 * Schritt ein. Keine editierbaren Action/Expected-Felder: {@code action} und
 * {@code expectedResult} bleiben null (BE-Pflicht bei kind=MODULE_REF), der
 * Modulname wandert in den Titel. Kein {@code libraryStepId} (keine Bibliotheks-Kopie).
 */
export function createLocalModuleRefStep(id: string, orderIndex: number, moduleId: string, name: string): TestStep {
  return {
    ...createLocalStep(id, orderIndex, '', null, null, {
      kind: 'MODULE_REF',
      calledModuleId: moduleId,
      title: name,
    }),
    // BE-Pflicht: bei kind=MODULE_REF muss action null sein (nicht der leere '' aus createLocalStep).
    action: null,
  };
}
